import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      height: '100vh',
    },
    wrapperContent: {
      maxWidth: '450px',
      marginBottom:'30px'
    },
    title: {
      color: '#0047BA',
      fontSize: '22px',
      fontWeight: 'bold',
      marginBottom: '10px',
      textAlign: 'center',
    },
    button: {
      height: '33px',
      color: '#646464',
      border: '1px solid #646464',
      borderRadius: '17px',
      padding: '10px 18px',
    },
    contentText: {
      textAlign: 'center',
    },
  })
);

export default useStyles;
